import { AbstractIconComponent } from '../abstract.icon'
import { Component } from '@angular/core'

@Component({
  selector: 'icon-ev-connector-cee-blue',
  templateUrl: './ev-connector-cee-blue.icon.html',
  styles: [
    `
      svg {
        width: 60px;
        height: 60px;
      }
    `,
  ],
})
export class EvConnectorCeeBlueComponent extends AbstractIconComponent {
  static icon = 'ev-connector-cee-blue'
}
